// extracted by mini-css-extract-plugin
export default {"container":"BookItem_container__yCA+u","highlight-search-match":"BookItem_highlight-search-match__0VeAu"};